import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-ph-50 h-flex-center h-flex-dir-column" }
const _hoisted_2 = { class: "b-calendar-sync__layout h-flex-center h-flex-dir-column" }
const _hoisted_3 = { class: "h-mt-50" }
const _hoisted_4 = { class: "h-font-18 h-fw-400 h-text-center" }
const _hoisted_5 = { class: "b-calendar-sync__layout--info h-flex h-flex-dir-column h-flex-center h-mt-20" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "h-font-18 h-text-center" }
const _hoisted_8 = { class: "h-mt-40" }
const _hoisted_9 = { class: "b-upload-avatar__txt h-font-16 h-fw-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FwButton = _resolveComponent("FwButton")!
  const _component_FwIcon = _resolveComponent("FwIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t('ONBOARDING.CALENDAR.SYNC.TITLE')), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('ONBOARDING.CALENDAR.SYNC.SUBTITLE')), 1),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("img", {
            src: _ctx.requireImage("icon_calendar_sync.svg")
          }, null, 8, _hoisted_6),
          _createElementVNode("p", _hoisted_7, [
            _createTextVNode(_toDisplayString(_ctx.$t('ONBOARDING.CALENDAR.SYNC.INFO')) + " ", 1),
            _cache[1] || (_cache[1] = _createElementVNode("span", { class: "h-fw-500" }, " Google Calendar, Outlook and Icloud ", -1)),
            _cache[2] || (_cache[2] = _createTextVNode(" calendars. ", -1))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_FwButton, {
          borderRadiusType: "tiny-border",
          disabled: "true",
          onClick: _ctx.goNextPage
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('BUTTON.NEXT')), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createElementVNode("div", {
        class: "h-mt-20 h-flex h-flex-center h-pointer",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goNextPage && _ctx.goNextPage(...args)))
      }, [
        _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t(`ONBOARDING.AVATAR.LATER`)), 1),
        _createVNode(_component_FwIcon, {
          class: "h-flex-center h-ml-20 h-pointer",
          icon: "arrow-right",
          size: "10",
          color: "rgba(33,63,107,.3)"
        })
      ])
    ])
  ]))
}